import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'xui-mat-phone-card',
    templateUrl: './app-mat-phone-card.component.html',
    styleUrls: ['./app-mat-phone-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule]
})
export class AppMatPhoneCardComponent {
    readonly number = input<string | undefined>();

    get telNumber(): string {
        const phoneNumber = this.number();
        return (phoneNumber && phoneNumber.length) ? phoneNumber : 'Not specified';
    }
}
